<template>
  <div class="product-operate-page">
    <!-- <div class="search">
      <div class="left">
        <el-form
          :inline="true"
          class="query-form"
          @submit.native.prevent
        >
          <el-row
            :gutter="20"
            class="query-row"
          >
            <el-col
              :span="queryKeywordSpan"
              class="query-item"
            >
              <el-form-item>
                <el-input
                  v-model.trim="search.keyword"
                  placeholder="请输入任务名称、聚合名称、产品名称"
                  clearable
                  style="width: 100%"
                  @keyup.enter.native="handleSearch"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="queryActionSpan"
              class="query-item query-item--actions"
            >
              <div class="query-buttons">
                <el-button
                  plain
                  type="primary"
                  @click="handleReset"
                >
                  重置
                </el-button>
                <el-button
                  type="primary"
                  @click="handleSearch"
                >
                  查询
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div> -->

    <div class="data" style="margin-bottom: 24px;">
      <!-- <div class="table-header-actions">
        <el-button
          type="primary"
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div> -->
      <el-table
        :data="list"
        border
      >
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            {{ scope.row[c.prop] || '--' }}
          </div>
        </el-table-column>
      </el-table>

      <!-- <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';

const req = new Request();

// const createDefaultSearch = () => ({
//   keyword: '',
// });

export default {
  name: 'product-operate',
  components: {
  },
  data() {
    return {
      // search: createDefaultSearch(),
      column: [
        { label: '序号', prop: 'serial_number' },
        { label: '产品系', prop: 'series_name' },
        { label: '产品', prop: 'product_names' },
        { label: '运营组长', prop: 'operation_leader_names' },
        { label: '直投运营', prop: 'direct_operator_names' },
        { label: '渠道运营', prop: 'channel_operator_names' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
    };
  },

  computed: {
    showQueryToggle() {
      return true;
    },
    queryKeywordSpan() {
      return 12;
    },
    queryActionSpan() {
      return 12
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.getList();
    },
    // // 搜索
    // handleSearch() {
    //   this.page = 1;
    //   this.getList();
    // },
    // handleReset() {
    //   this.search = createDefaultSearch();
    //   this.page = 1;
    //   this.getList();
    // },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.productOperate.list, {
          // keyword: this.search.keyword,
          // page: this.page,
          // page_size: this.pageSize,
        });
        this.list = data || [];
        this.total = Number((data || []).length);
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },
  },
};
</script>

<style lang="less">
.table-header-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
}
.product-operate-page {
  .search {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .left {
    flex: 1;
  }

  .right {
    flex-shrink: 0;
  }

  .query-form {
    width: 100%;
  }

  .query-item {
    margin-bottom: 12px;
  }

  .query-item--actions {
    display: flex;
    align-items: flex-start;
  }

  .query-buttons {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .query-toggle {
    padding: 0;
  }

  .data {
    margin-top: 20px;

    .page {
      margin-top: 20px;
      text-align: right;
    }
  }

  .dialog {
    .input {
      width: 400px;
    }
  }
}

.product-operate-page .query-form .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

.product-operate-page .query-form .el-form-item__content {
  width: 100%;
}

.product-operate-page .query-buttons .el-button + .el-button {
  margin-left: 0;
}
</style>
